"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CACHE_PREFIX = 'company';
// cached for 5 minute
var CACHE_DURATION = 5;
function SDK(baseUrl, fetch, cacheInterface, ignorePromises, cacheDurationMinutes) {
  // Private
  function fetchJson(url) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, res, data, _res, _data, text;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      if (options && options.body) {
        options.headers = _objectSpread(_objectSpread({}, options.headers || {}), {}, _defineProperty({}, 'content-type', 'application/json'));
      }
      // some of the sdks are used in the browswer where the native fetch is used.
      if (typeof window === 'undefined') {
        options.responseType = 'json';
        var $Try_1_Post = function () {
          try {
            return $If_2.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this);
        var $Try_1_Catch = function (error) {
          try {
            data = error.response.body;
            throw _objectSpread({
              status: error.statusCode
            }, data);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        };
        try {
          return Promise.resolve(fetch("".concat(baseUrl).concat(url), options)).then(function ($await_6) {
            try {
              res = $await_6;
              return $return(res.body);
            } catch ($boundEx) {
              return $Try_1_Catch($boundEx);
            }
          }, $Try_1_Catch);
        } catch (error) {
          $Try_1_Catch(error)
        }
      } else {
        return Promise.resolve(fetch("".concat(baseUrl).concat(url), options)).then(function ($await_7) {
          try {
            _res = $await_7;
            if (_res.ok) {
              return Promise.resolve(_res.json()).then($return, $error);
            } else {
              if (_res.headers.get('Content-Type').indexOf('application/json') !== -1) {
                return Promise.resolve(_res.json()).then(function ($await_9) {
                  try {
                    _data = $await_9;
                    return $error(_objectSpread({
                      status: _res.status
                    }, _data));
                  } catch ($boundEx) {
                    return $error($boundEx);
                  }
                }, $error);
              }
              return Promise.resolve(_res.text()).then(function ($await_10) {
                try {
                  text = $await_10;
                  return $error(text);
                } catch ($boundEx) {
                  return $error($boundEx);
                }
              }, $error);
            }
            return $If_2.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this), $error);
      }
      function $If_2() {
        return $return();
      }
    });
  }

  // use whatever is passed in or set to default
  cacheDurationMinutes = cacheDurationMinutes || CACHE_DURATION;
  var _getKey = function _getKey(key) {
    return cacheInterface.getKey(CACHE_PREFIX, key);
  };
  var _cacheGet = function _cacheGet(key) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      if (options.hardRefresh) {
        return $return(undefined);
      }
      return Promise.resolve(cacheInterface.get(_getKey(key))).then($return, $error);
    });
  };
  var _cacheSet = function _cacheSet(key, value, ttl) {
    return cacheInterface.set(_getKey(key), value, ttl);
  };
  var _cacheSetPromise = function _cacheSetPromise(key, value) {
    if (ignorePromises) {
      return value;
    }
    return cacheInterface.set(_getKey(key), value, cacheDurationMinutes, true);
  };
  var _cacheClearByKeyStartsWith = function _cacheClearByKeyStartsWith(partialKey) {
    return new Promise(function ($return, $error) {
      return $return(cacheInterface.clearByKeyStartsWith(_getKey(partialKey)));
    });
  };
  var _clearByKey = function _clearByKey(key) {
    return cacheInterface.clearByKey(_getKey(key));
  };

  // Companies
  var getCompanies = function getCompanies(searchQuery, includeArchived) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, query, queryString, key, cached, response;
      options = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      query = [];
      if (searchQuery) {
        query.push("query=".concat(encodeURIComponent(searchQuery)));
      }
      if (includeArchived) {
        query.push("includeArchived=".concat(!!includeArchived));
      }
      queryString = query.join('&');
      key = "companies-".concat(queryString);
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_12) {
        try {
          cached = $await_12;
          if (cached) {
            return $return(cached);
          }
          return Promise.resolve(_cacheSetPromise(key, fetchJson("/companies?".concat(queryString)))).then(function ($await_13) {
            try {
              response = $await_13;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var saveCompany = function saveCompany(company) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(fetchJson('/company', {
        method: 'POST',
        body: JSON.stringify(company)
      })).then(function ($await_14) {
        try {
          response = $await_14;
          if (company.id) {
            _clearByKey("company-".concat(company.id));
            return $If_5.call(this);
          } else {
            return Promise.resolve(_cacheClearByKeyStartsWith('companies')).then(function ($await_15) {
              try {
                return $If_5.call(this);
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }.bind(this), $error);
          }
          function $If_5() {
            return $return(response);
          }
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }.bind(this), $error);
    });
  };
  var getCompany = function getCompany(companyId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var isAllCampaigns, options, personId, key, cached, response;
      isAllCampaigns = $args.length > 1 && $args[1] !== undefined ? $args[1] : false;
      options = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      personId = $args.length > 3 ? $args[3] : undefined;
      key = "company-".concat(companyId);
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_16) {
        try {
          cached = $await_16;
          if (cached) {
            return $return(cached);
          }
          return Promise.resolve(_cacheSetPromise(key, fetchJson("/company/".concat(encodeURIComponent(companyId)).concat(personId ? "/".concat(personId) : '', "?isAllCampaigns=").concat(isAllCampaigns)))).then(function ($await_17) {
            try {
              response = $await_17;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var deleteCompany = function deleteCompany(companyId) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(fetchJson("/company/".concat(encodeURIComponent(companyId)), {
        method: 'DELETE'
      })).then(function ($await_18) {
        try {
          response = $await_18;
          // don't hold up response by awaiting
          _clearByKey("company-".concat(companyId));
          return Promise.resolve(_cacheClearByKeyStartsWith('companies')).then(function ($await_19) {
            try {
              return $return(response);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  // Public
  return {
    getCompanies: getCompanies,
    saveCompany: saveCompany,
    getCompany: getCompany,
    deleteCompany: deleteCompany
  };
}
var noCache = {
  getKey: function getKey() {
    return '';
  },
  get: function get() {
    return new Promise(function ($return, $error) {
      return $return(undefined);
    });
  },
  set: function set(key, value, lifetimeMins) {
    return new Promise(function ($return, $error) {
      return $return(value);
    });
  },
  clear: function clear() {
    return undefined;
  },
  clearByKey: function clearByKey() {
    return undefined;
  },
  clearByKeyStartsWith: function clearByKeyStartsWith() {
    return new Promise(function ($return, $error) {
      return $return(undefined);
    });
  }
};
module.exports = function (url, customFetch) {
  var cacheInterface = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noCache;
  var ignorePromises = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var cacheDurationMinutes = arguments.length > 4 ? arguments[4] : undefined;
  if (typeof customFetch !== 'function') {
    throw new Error("".concat(_typeof(customFetch), " is not a function"));
  }
  return new SDK(url, customFetch, cacheInterface, ignorePromises, cacheDurationMinutes);
};
//# sourceMappingURL=index.js.map